<script setup>
  const { error, retry } = defineProps({
    error: { type: Object },
    retry: { type: Function }
  })

  const dev = process.dev
</script>

<template>
  <div class="flex flex-col items-center justify-center space-y-2 text-center sm:flex-row sm:space-x-4 sm:space-y-0">
    <Icon class="text-zinc-300" name="face-confused" size="3x" type="regular" />
    <div class="space-y-2">
      <div class="text-zinc-500">Une erreur s’est produite</div>
      <div v-if="dev">[{{ error?.statusCode }}] {{ error?.message }}</div>
      <button class="text-viking-400 duration-300 hover:text-viking-500" v-if="retry" @click="retry">Réessayer</button>
    </div>
  </div>
</template>
